<template>
  <div>
      <h1 class="mobiTitle white lg content" id="contentTitle">
        {{getSubCategory(lang_a4all)}} 
      </h1>
      <div class="main_wrap">
        <div class="mobiSection">
          <div v-if="isLoaded === false">
            <svg class="spinner" viewBox="0 0 50 50">
              <circle
                class="path"
                cx="25"
                cy="25"
                r="20"
                fill="none"
                stroke-width="5"
              ></circle>
            </svg>
          </div>
          <div class="mobiSection__header" v-else>
              <h2 class="mobiTitle md">
                  <span :class="icon"> </span>
                  <span class="text_color">{{ $t("all")}} {{getSubCategory(lang_a4all)}}</span>
              </h2>
          </div>
          <div class="mobiSection__content">
            <div v-if="category === 'video'">
              <div class="row">
                <div  v-for="hot in data" :key="hot.key" class="col-12 col-md-4 col-lg-4 col-sm-6 mobiColItem"  >          
                  <router-link class="browse_link mobiVideo" :to="{
                      name: 'DetailPage',
                      params: { id: hot.id }
                      }">
                    <div class="mobiVideo__thumb">
                      <img class="img_wrp" :src="hot.cover_img" alt="" />
                    </div>
                    <div class="playBtn"><span></span></div>
                    <div class="mobiVideo__info">
                      <!-- <span v-if="lang_a4all !== 'english'">
                        <h3 class="mobiTitle sm" v-if="hot[`cont_name_${lang_a4all}`] !== ''">{{ hot[`cont_name_${lang_a4all}`] }}</h3>
                        <h3 class="mobiTitle sm" v-else>{{ hot[`content_name`] }}</h3>
                      </span>
                      <span v-else>
                        <h3 class="mobiTitle sm">{{ hot.content_name }}</h3>
                      </span> -->
                      <span v-if="lang_a4all !== 'english'">
                        <h3 class="mobiTitle sm" v-if="hot[`cont_name_${lang_a4all}`] !== ''">{{ hot[`cont_name_${lang_a4all}`] }}</h3>
                        <h3 class="mobiTitle sm" v-else>{{ hot[`cont_name_english`] }}</h3>
                      </span>
                      <span v-else>
                        <h3 class="mobiTitle sm">{{ hot[`cont_name_english`] }}</h3>
                      </span>
                      <div>
                        <!-- <p>{{ hot.total_download }} {{$t("downloads")}}</p> -->
                        <star-rating :inline="true" :star-size="16" :read-only="true" :increment="0.01"  active-color="#ffc838" :show-rating="false" :border-width="2" border-color="#feb801" :rounded-corners="false" inactive-color="#00923d" :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]" :rating="Number(hot.rating)"></star-rating>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="row">
                <div class="col-6 col-md-3 col-lg-2 col-sm-3 mobiColItem" v-for="dat in data" :key="dat.key">
                  <router-link class="browse_link mobiApp" :to="{
                    name: 'DetailPage',
                    params: { id: dat.id }
                    }">
                    <div v-if="dat.content_type === 'application/x-zip-compressed' && dat.category === 'Game'" class="mobibadge badge--html5">
                      <img src="../../../assets/apps4all/imgs/html5-badge.png"/>
                    </div>
                    <div class="mobiApp__thumb">
                      <img class="img_wrp" :src="dat.thumbnail_url" alt="" />
                    </div>
                    <div class="mobiApp__info">
                      <span v-if="lang_a4all !== 'english'">
                        <h3 class="mobiTitle sm text_color" v-if="dat[`cont_name_${lang_a4all}`] !== ''">{{ dat[`cont_name_${lang_a4all}`] }}</h3>
                        <h3 class="mobiTitle sm text_color" v-else>{{ dat[`cont_name_english`] }}</h3>
                      </span>
                      <span v-else>
                        <h3 class="mobiTitle sm text_color">{{ dat[`cont_name_english`] }}</h3>
                      </span>
                      <div>   
                        <!-- <p>{{ dat.total_download }} Downloads</p> -->
                        <star-rating :inline="true" :star-size="16" :read-only="true" :increment="0.01"  active-color="#ffc838" :show-rating="false" :border-width="3" border-color="#feb801" :rounded-corners="false" inactive-color="#00923d" :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]" :rating="Number(dat.rating)"></star-rating>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        <!-- <router-link style="text-decoration:none;" :to="{
            name: 'Category',
            params: { category: category}
            }" class="browse_link">
        {{category}}</router-link> -->

        <!-- <h1 class="main_title">{{subcategory}}</h1> -->
        <!-- <select name="" id="" @change="getSubContent($event)">
            <option value="">--Select View--</option>
            <option value="200">200</option>
            <option value="100">100</option>
            <option value="50">50</option>
            <option value="20">20</option>
            <option value="10">10</option>
            <option value="5">5</option>
        </select> -->
      
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import StarRating from 'vue-star-rating';
// Vue.component("star-rating", VueStarRating.default);

export default {
  data() {
    return {
      category: "",
      subcategory: "",
      subcategoryTanslate: "",
      data: {},
      icon: "",
      isLoaded: false,
    };
  },
  components:{
    StarRating
  },
  computed: mapGetters([
    "allSubcategory_a4all",
    "lang_a4all",
    "country_a4all",
    "host_a4all",
  ]),
  created() {
    //replace '_' with blank space
    let subcategory = this.$route.params.subcat;
    let category = this.$route.params.category;

    subcategory = subcategory.replace("_", " ");
    this.subcategory = subcategory;
    category = category.replace("_", " ");
    this.category = category;

    this.fetchAllSubcategory_a4all(this.subcategory);

    let e = undefined;
    this.getSubContent(e);
  },
  methods: {
    ...mapActions(["fetchAllSubcategory_a4all"]),
    async getSubContent(e) {
      let limit = 0;

      if (e != undefined) {
        limit = parseInt(
          e.target.options[e.target.options.selectedIndex].value
        );
      } else {
        //default
        limit = 100;
      }

      let local = `http://[::1]/PuretechGlobalContentPortal/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=${this.subcategory}&limit=${limit}&offset=0&domain=${this.host_fplus}`;
      let live = `http://cook.grabmobi.com/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=${this.subcategory}&limit=${limit}&offset=0&domain=${this.host_fplus}`;
      await axios
        .get(live)
        .then((res) => {
          console.log(res.data.data);
          let data = res.data.data;
          // data = data.filter((value)=>{
          //   if(value.category.toLowerCase() == this.category){
          //     return value;
          //   }
          // })
          this.isLoaded = true;
          this.data = data;
        })

        .catch((err) => {
          console.log(err);
        });
    },
    getSubCategory(lang) {
      let allSubcategory = [...this.allSubcategory_a4all];

      let subcat = allSubcategory.map((item) => {
        if (item.subcategory_translate != null) {
          let sub_trans = JSON.parse(item.subcategory_translate);
          let trans_len = Object.keys(sub_trans).length;
          let trans_arr = Object.keys(sub_trans);

          item.titleSub_english = item.subcategory;
          if (sub_trans != null) {
            for (let i = 0; i < trans_len; i++) {
              if (lang == "english") {
                item[`titleSub_english`] = this.subcategory;
              } else {
                item[`titleSub_${trans_arr[i]}`] =
                  sub_trans[trans_arr[i]].title;
              }
            }
          }
        }

        return item;
      });

      if (subcat[0] != undefined) {
        return subcat[0][`titleSub_${lang}`];
      }
    },
  },
};
</script>

<style scoped>
.main_title {
  color: black;
  text-transform: uppercase;
}

.main_part div {
  display: inline-block;
  padding: 0 3px;
  color: black;
}

img.icons {
  background: black;
  height: 32px;
}

.col-12.col-md-4.col-lg-4.col-sm-6.mobiColItem {
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/apps4all/browse/Subcategory.vue